<template>
  <div class="page">
    <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
      <van-swipe-item v-for="(item, index) in swipeData" :key="index"
        ><img :src="item.img" alt="" @click="toUrl(item.link)"
      /></van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Toast, Swipe, SwipeItem } from "vant";
import { getBanner } from "@/api/product";
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
import Vue from "vue";
export default {
  mounted() {
    getBanner().then((res) => {
      res.sort((a, b) => {
        return a.sort - b.sort;
      });
      this.swipeData = res;
    });
  },
  data() {
    return {
      swipeData: [],
    };
  },
  methods: {
    toUrl(url) {
      console.log("utl", url);
      if (url) {
        window.location.href = url;
      }
    },
  },
};
</script>
<style scoped>
.page {
  /* padding-top: 4vw; */
}
.item-box {
  background: white;
  border-radius: 14px;
  padding: 4vw;
  /* box-shadow: 0 4px 12px rgba(0,0,0,.1); */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4vw;
}
.my-swipe {
  height: 43vw;
}
.my-swipe .van-swipe-item {
  padding: 4vw 4vw 0 4vw;
}
.my-swipe .van-swipe-item img {
  display: block;
  width: 100%;
  /* height: 100%; */
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/swipePoster.vue